import React from "react";
import Codebox from "components/common/Codebox";

export default function AccessDocumentWidgetBody() {
  const REACT_APP_BASE_URL = "https://portal.itscredible.com";
  const ACCESS_DOCUMENT_WIDGET_CODE = `<div id="vmAccessDocumentWidget"></div>\n<script src="${REACT_APP_BASE_URL}/credulocker.js"></script>`;

  return <Codebox mt={1}>{ACCESS_DOCUMENT_WIDGET_CODE}</Codebox>;
}
